const TERMS_OF_ACCEPTANCE_ROUTES = {
  path: '/terms-of-acceptance',
  component: () =>
    import('@/pages/TermsOfAcceptance/TermsOfAcceptancePagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'terms-of-acceptance.index',
      component: () =>
        import('@/pages/TermsOfAcceptance/TermsOfAcceptancePage.vue'),
    },
    {
      path: 'create',
      name: 'terms-of-acceptance.create',
      component: () =>
        import('@/pages/TermsOfAcceptance/TermOfAcceptanceFormPage.vue'),
    },
    {
      path: ':id/edit',
      name: 'terms-of-acceptance.edit',
      component: () =>
        import('@/pages/TermsOfAcceptance/TermOfAcceptanceFormPage.vue'),
    },
  ],
};

export default TERMS_OF_ACCEPTANCE_ROUTES;
